<div class="admin-modal edit-system-account-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">System-Form Acct Mapping</h3>
    <div class="header-actions">
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    @if (!loading) {
<form #editForm="ngForm" novalidate>

      <!-- Top read-only row (Acct Type + System Account). Wrapped in a panel so
           it shares the same chrome and inner padding as every other section in
           the modal — that way its controls align horizontally with the form
           rows below and the panel's own bottom margin produces a clean gap. -->
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row top-row">
            <div class="top-cell">
              <label>Acct Type:</label>
              <input type="text" class="form-control" name="acctType"
                     [value]="code_desc" readonly>
            </div>

            <div class="top-cell top-cell-wide">
              <label>System Account:</label>
              <input type="text" class="form-control" name="systemAcct"
                     [value]="CHECK_SYS_ACCT" readonly>
            </div>
          </div>
        </div>
      </div>

      <!-- Action panel + conditional content -->
      <div class="panel panel-default">
        <div class="panel-heading panel-heading-flex">
          @if (mode === 'edit') {
<span>Edit System Acct to Form Line Mapping</span>
}
          @if (mode === 'add') {
<span>System to form mapping</span>
}
          @if (mode === 'toggleClient') {
<span>Activate/De-activate system account</span>
}
          @if (mode === 'lookup') {
<span>System Account Mappings</span>
}

          <div class="panel-heading-actions">
            <button type="button" class="btn btn-success btn-xs" (click)="formAdd()">Add</button>
            <button type="button" class="btn btn-success btn-xs"
                    (click)="formAdd('toggleClient')">Activate/Deactivate</button>
            <button type="button" class="btn btn-success btn-xs" (click)="toggleLookup()">Reset</button>
          </div>
        </div>

        <!-- Edit / Add: cascading form mapping rows + client selector -->
        @if (lookUpMapping && (mode === 'edit' || mode === 'add')) {
<div class="panel-body">
          @for (formLine of formLineMapping; track $index; let i = $index; let last = $last) {
<div class="row form-line-row">
            <div class="col">
              <label>IRS Form</label>
              <ap-dropdown class="field-full-width" [list]="formLookupItems" [selectType]="'single'"
                [title]="'IRS Form'" [hideTitleOnInput]="true" [inputAriaLabel]="'IRS Form'"
                [ngModel]="getRowSelectedItem(loadLookupForm, formLine.form)" [name]="'edit_form_' + i"
                (onSelect)="onRowPrimitiveSelect($event, formLine, 'form', i)">
                @for (item of formLookupItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'IRS Form')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            <div class="col">
              <label>Schedule</label>
              <ap-dropdown class="field-full-width" [list]="getRowLookupItems(scheduleLookup[i])" [selectType]="'single'"
                [title]="'Schedule'" [hideTitleOnInput]="true" [inputAriaLabel]="'Schedule'"
                [disabled]="!formLine.form"
                [ngModel]="getRowSelectedItem(scheduleLookup[i], formLine.schedule)" [name]="'edit_schedule_' + i"
                (onSelect)="onRowPrimitiveSelect($event, formLine, 'schedule', i)">
                @for (item of getRowLookupItems(scheduleLookup[i]); track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Schedule')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            <div class="col col-form-line">
              <label>Line</label>
              <ap-dropdown class="field-full-width" [list]="getRowLookupItems(lineLookup[i])" [selectType]="'single'"
                [title]="'Line'" [hideTitleOnInput]="true" [inputAriaLabel]="'Line'"
                [disabled]="!formLine.schedule"
                [ngModel]="getRowSelectedItem(lineLookup[i], formLine.line)" [name]="'edit_line_' + i"
                (onSelect)="onRowPrimitiveSelect($event, formLine, 'line', i)">
                @for (item of getRowLookupItems(lineLookup[i]); track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Line')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            <div class="col">
              <label>Column</label>
              <ap-dropdown class="field-full-width" [list]="getRowLookupItems(columnLookup[i])" [selectType]="'single'"
                [title]="'Column'" [hideTitleOnInput]="true" [inputAriaLabel]="'Column'"
                [disabled]="!formLine.line"
                [ngModel]="getRowSelectedItem(columnLookup[i], formLine.column)" [name]="'edit_column_' + i"
                (onSelect)="onRowPrimitiveSelect($event, formLine, 'column', i)">
                @for (item of getRowLookupItems(columnLookup[i]); track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Column')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            <div class="col">
              <label>Section</label>
              <ap-dropdown class="field-full-width" [list]="getRowLookupItems(sectionLookup[i])" [selectType]="'single'"
                [title]="'Section'" [hideTitleOnInput]="true" [inputAriaLabel]="'Section'"
                [disabled]="!formLine.column"
                [ngModel]="getRowSelectedItem(sectionLookup[i], formLine.section)" [name]="'edit_section_' + i"
                (onSelect)="onRowPrimitiveSelect($event, formLine, 'section', i)">
                @for (item of getRowLookupItems(sectionLookup[i]); track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Section')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            <div class="col">
              <label>Part</label>
              <ap-dropdown class="field-full-width" [list]="getRowLookupItems(partLookup[i])" [selectType]="'single'"
                [title]="'Part'" [hideTitleOnInput]="true" [inputAriaLabel]="'Part'"
                [disabled]="!formLine.section"
                [ngModel]="getRowSelectedItem(partLookup[i], formLine.part)" [name]="'edit_part_' + i"
                (onSelect)="onRowPrimitiveSelect($event, formLine, 'part', i)">
                @for (item of getRowLookupItems(partLookup[i]); track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Part')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            <div class="col">
              <label>Form Chart:</label>
              <ap-dropdown class="field-full-width" [list]="formChartItems" [selectType]="'single'"
                [title]="'Form Chart'" [hideTitleOnInput]="true" [inputAriaLabel]="'Form Chart'"
                [ngModel]="findDropdownItemByValue(formChartItems, formLine.form_chart_key)" [name]="'edit_form_chart_' + i"
                (onSelect)="onFormChartSelect($event, formLine)">
                @for (item of formChartItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'Form Chart')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
            </div>
            @if (last && mode === 'add') {
<div class="col col-add add-row-cell">
              <label>Add New Form Line:</label>
              <i class="fa fa-plus-circle add-icon"
                 (click)="addNewFormLineMapping()"></i>
            </div>
}
          </div>
}

          <div class="row client-row">
            <div class="col-md-3 client-toggle">
              <ap-checkbox name="client_specific_edit" inputId="cs_edit"
                          [(ngModel)]="isClientSpecific"
                          [ariaLabel]="'Is client specific'">
              </ap-checkbox>
              <label for="cs_edit">Is client specific</label>
            </div>

            @if (isClientSpecific) {
<div class="col-md-3">
              <label>Select Client:</label>
              <ap-dropdown name="clients_edit"
                             [list]="clientDropdownList"
                             [(ngModel)]="selectedClientList"
                             [selectType]="'multiple'"
                             [enableNgContent]="false"
                             [optionName]="'label'"
                             [optionValue]="'id'"
                             [title]="'Select clients'"
                             [inputAriaLabel]="'Select Client'"
                             [hideTitleOnInput]="true"
                             [showSearchbox]="true"
                             [showSelectAll]="true"
                             [clearSearchKeyword]="true"
                             (onFilterResult)="onClientFilterResult($event)"
                             style="width:100%">
              </ap-dropdown>
            </div>
}

            @if (isClientSpecific) {
<div class="col-md-6">
              <div class="entitie-holder">
                @for (entity of selectedClientList; track $index; let i = $index) {
<div class="btn-group">
                  <button type="button" class="btn btn-xs btn-default">{{ entity.label }}</button>
                  <button type="button" class="btn btn-xs btn-danger" (click)="removeClient(i)">
                    <span class="fa fa-times"></span>
                  </button>
                </div>
}
              </div>
            </div>
}
          </div>
        </div>
}

        <!-- Toggle client section -->
        @if (mode === 'toggleClient') {
<div class="panel-body">
          <div class="row">
            <div class="col-md-3">
              <label>Select Client:</label>
              <ap-dropdown name="clients_toggle"
                             [list]="clientDropdownList"
                             [(ngModel)]="selectedClientList2"
                             [selectType]="'multiple'"
                             [enableNgContent]="false"
                             [optionName]="'label'"
                             [optionValue]="'id'"
                             [title]="'Select clients'"
                             [inputAriaLabel]="'Select Client'"
                             [hideTitleOnInput]="true"
                             [showSearchbox]="true"
                             [showSelectAll]="true"
                             [clearSearchKeyword]="true"
                             (onFilterResult)="onClientFilterResult($event)"
                             style="width:100%">
              </ap-dropdown>
            </div>

            <div class="col-md-9">
              <div class="entitie-holder">
                @for (entity of selectedClientList2; track $index; let i = $index) {
<div class="btn-group">
                  <button type="button" class="btn btn-xs btn-default">{{ entity.label }}</button>
                  <button type="button" class="btn btn-xs btn-danger" (click)="removeClient2(i)">
                    <span class="fa fa-times"></span>
                  </button>
                </div>
}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 toggle-actions">
              <button class="btn btn-info btn-sm" type="button"
                      (click)="toggleClient('A')" [disabled]="crudLoading">
                @if (crudLoading) {
<i class="fa fa-spinner fa-pulse"></i>
} Activate
              </button>
              <button class="btn btn-danger btn-sm" type="button"
                      (click)="toggleClient('N')" [disabled]="crudLoading">
                Deactivate
              </button>
            </div>
          </div>
        </div>
}
      </div>

      <!-- Existing mappings table -->
      @if (loadSystemAndLocalAccountData.length > 0) {
<div class="mappings-table-wrapper">
        @if (sysacctloading) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
}
        @if (!sysacctloading) {
<table class="table table-bordered table-striped table-condensed mappings-table"
              >
          <thead>
            <tr>
              <th>Action</th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('FORM')"></i> IRS Form
              </th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('SCHEDULE')"></i> Schedule
              </th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('LINE')"></i> Line No.
              </th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('LINE_DESC')"></i> Line Description
              </th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('COL')"></i> Column
              </th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('SECTION')"></i> Section
              </th>
              <th>
                <i class="fa fa-sort sort-icon" (click)="setSort('PART')"></i> Part
              </th>
            </tr>
          </thead>
          <tbody>
            @for (t of loadSystemAndLocalAccountData; track $index; let i = $index) {
<tr>
              <td class="text-align">
                <i class="fa fa-edit pointer pr-5"
                   (click)="formEdit(t, i)"></i>
                <span><i>Edit</i></span>
              </td>
              <td>{{ t.FORM }}</td>
              <td>{{ t.SCHEDULE }}</td>
              <td>{{ t.LINE }}</td>
              <td>{{ t.LINE_DESC }}</td>
              <td>{{ t.COL }}</td>
              <td>{{ t.SECTION }}</td>
              <td>{{ t.PART }}</td>
            </tr>
}
          </tbody>
        </table>
}
      </div>
}
    </form>
}
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button"
            (click)="save()"
            [disabled]="mode === 'lookup' || mode === 'toggleClient' || crudLoading">
      @if (crudLoading) {
<i class="fa fa-spinner fa-pulse"></i>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
